// features/item-filter/useItemSuggestions.js
//
// The items a search box suggests for a typed term — one home for that request,
// so every box that suggests items (the filter bar, a popup's "add an item" or
// "match to…" box) asks the server the same question. The fetch half of a
// TypeaheadSearchField over items; useTypeaheadSuggestions owns the debounce,
// the abort and the failure report.

import { useTypeaheadSuggestions } from '../../hooks/useTypeaheadSuggestions';

const PAGE_SIZE = 50;

const itemSuggestionsUrl = (term) => (
  `/api/items/?search=${encodeURIComponent(term)}&page_size=${PAGE_SIZE}`
);

/** `{ suggestions, loading, failed }` for `term`; nothing is fetched while
 *  `skip`. */
export function useItemSuggestions(term, { skip = false } = {}) {
  return useTypeaheadSuggestions({
    term,
    skip,
    buildUrl: itemSuggestionsUrl,
    label: 'item',
  });
}
